import { Box, Stack, Typography, Container, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { getMyLearningUrl } from 'core/navigationHelpers';

const SubHeader = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(getMyLearningUrl(new Date(2025, 4, 1).toISOString(), 5));
  };

  return (
    <Box
      sx={{
        position: 'sticky',
        top: { xs: '59px', sm: '72px' },
        zIndex: 10,
        height: '52px',
        borderBottom: '1px solid #e5e5e5',
        backgroundColor: 'white',
      }}
    >
      <Container maxWidth="md" sx={{ height: '100%', display: 'flex', alignItems: 'center', py: 0 }}>
        <Stack sx={{ width: '100%' }} direction="row" alignItems="center">
          <IconButton onClick={handleGoBack} sx={{ mr: { md: 2, xs: 1 } }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" sx={{ fontWeight: '700' }}>
            Back to My Learning
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
};

export default SubHeader;
